/** L'illustration du support : une maison qui parle (decision Q4) */
export function SupportIllustration({ size = 34 }: { size?: number }) {
  return (
    <svg viewBox="0 0 40 40" width={size} height={size} fill="none" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M7 19 17 11l10 8" stroke="#1d4ed8" strokeWidth="2.2" />
      <path d="M9.5 17.5V30h15V17.5" fill="#fff" stroke="#1d4ed8" strokeWidth="2.2" />
      <rect x="14.5" y="23" width="5" height="7" rx="1" fill="#dbeafe" stroke="#1d4ed8" strokeWidth="1.6" />
      <path d="M22 6h12a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-6l-4 3v-3h-2a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3z" fill="#2563eb" />
      <path d="M26.2 10.4a2.3 2.3 0 0 1 4.4.9c0 1.4-2.1 2-2.1 2" stroke="#fff" strokeWidth="1.6" />
      <circle cx="28.5" cy="15.3" r=".4" fill="#fff" stroke="#fff" />
    </svg>
  );
}
